// Consent Service for saving treatment consent data and sending emails/PDF

const getApiBaseUrl = () => {
  if (process.env.NODE_ENV === 'development') return 'http://localhost:3001';
  return '';
};

export const saveConsentData = async (consentPayload) => {
  try {
    const base = getApiBaseUrl();
    const res = await fetch(`${base}/api/consents`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(consentPayload),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Failed to save consent data');
    return { success: true, ...data };
  } catch (err) {
    console.error('ConsentService.saveConsentData error:', err);
    return { success: false, error: err.message };
  }
};

// Ask backend to generate a PDF summary and email to patient and practice
export const sendConsentEmails = async (consentPayload) => {
  try {
    const base = getApiBaseUrl();
    const res = await fetch(`${base}/api/consents/send-emails`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(consentPayload),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Failed to send consent emails');
    return { success: true, ...data };
  } catch (err) {
    console.error('ConsentService.sendConsentEmails error:', err);
    return { success: false, error: err.message };
  }
};
